import {initialState, NAME_SLICE} from "./constants";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IVessel} from "../../varibles/interface";

const vesselSlice = createSlice({
    name: NAME_SLICE,
    initialState,
    reducers: {
        gets: (state) => {
            state.loading = true;
        },
        getsSuccess: (state, action: PayloadAction<IVessel[]>) => {
            state.loading = false;
            state.data = action.payload;
        },
        getsFailure: (state) => {
            state.loading = false;
        },
        getVesselContracts: (state) => {
            state.vesselContracts.loading = true;
        },
        getVesselContractsSuccess: (state, action: PayloadAction<IVessel[]>) => {
            state.vesselContracts.loading = false;
            state.vesselContracts.data = action.payload;
        },
        getVesselContractsFailure: (state) => {
            state.vesselContracts.loading = false;
        },
        add: (state, action) => {
            const factory = action.payload;
            const {data} = state;
            state.data = [...data, factory];
        },
        update: (state, action) => {
            const factory = action.payload;
            const {data} = state;
            state.data = data.map(item => item.id === factory.id ? factory : item)
        },
        delete: (state, action) => {
            const id = action.payload;
            const {data} = state;
            state.data = data.filter(item => item.id !== id);
        },
    },
})

export const vesselActions = vesselSlice.actions

const vesselReducer = vesselSlice.reducer;

export default vesselReducer;
